import { Box, Typography } from "@mui/material";
import { DossierDetailType } from "../../../types";
import CloseIcon from "@mui/icons-material/Close";
import DossiersToAssignCardList from "./DossiersToAssignCards/DossiersToAssignCardList";
import BulkAssignedFooter from "./BulkAssignedFooter";
import { useState } from "react";

type BulkAssignedProps = {
    dossiers: DossierDetailType[];
    close: Function;
    instructorList: any[];
    toBulkAssignedDossier: Function;
};

export default function BulkAssigned({
    dossiers,
    close,
    instructorList,
    toBulkAssignedDossier,
}: BulkAssignedProps) {
    const [selectedDossiersToAssign, setSelectedDossiersToAssign] = useState<
        number[]
    >([]);

    const initInstructorId = instructorList[0].id;

    const [selectedInstructor, setSelectedInstructor] = useState<number | null>(
        initInstructorId
    );

    const handleInstructorSelect = (selectedInstructorValue: number) => {
        setSelectedInstructor(selectedInstructorValue);
    };

    const handleDossiersToAssignSelect = (
        dossierId: number,
        isSelected: boolean
    ) => {
        if (isSelected) {
            setSelectedDossiersToAssign([
                ...selectedDossiersToAssign,
                dossierId,
            ]);
        } else {
            setSelectedDossiersToAssign(
                selectedDossiersToAssign.filter((id) => id !== dossierId)
            );
        }
    };

    const handleBulkAssignedDossier = async () => {
        await toBulkAssignedDossier(
            selectedDossiersToAssign,
            selectedInstructor
        );
    };

    const disabledBulkAssignBtn = !selectedDossiersToAssign.length;

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    alignSelf: "stretch",
                    padding: "4rem",
                    "@media (max-width:1024px)": {
                        padding: "unset",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            flexWrap: "wrap",
                            gap: "10rem",
                            "@media (max-width:1024px)": {
                                flexFlow: "row",
                                gap: 0,
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#023",
                                fontFamily: "Roboto",
                                fontSize: "1.25rem",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "normal",
                            }}
                        >
                            Sélectionnez les dossiers à affecter
                        </Typography>
                        <CloseIcon
                            onClick={() => {
                                close();
                            }}
                            sx={{
                                width: "1.5rem",
                                height: "1.5rem",
                                //position: "absolute",
                                right: "4rem",
                                top: "4rem",
                                cursor: "pointer",
                            }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            color: "#023",

                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                        }}
                    >
                        {`${selectedDossiersToAssign.length} dossier(s) sélectionné(s)`}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "2rem",
                        alignSelf: "stretch",
                        position: "relative",
                    }}
                >
                    <DossiersToAssignCardList
                        dossiers={dossiers}
                        handleDossiersToAssignSelect={
                            handleDossiersToAssignSelect
                        }
                    />
                </Box>
            </Box>
            <BulkAssignedFooter
                instructorList={instructorList}
                onInstructorSelect={handleInstructorSelect}
                handleBulkAssignedDossier={handleBulkAssignedDossier}
                disabledBulkAssignBtn={disabledBulkAssignBtn}
                initInstructorId={initInstructorId}
            />
        </>
    );
}
